export default __webpack_public_path__ + "locales/el-GR/Files.json?hash=6a032c34255e32965c00afa47f9e22b7";